import { render } from "./LdvsTable.vue?vue&type=template&id=60079bbb"
import script from "./LdvsTable.vue?vue&type=script&lang=js"
export * from "./LdvsTable.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./LdvsTable.vue?vue&type=style&index=0&id=60079bbb&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script